import {StoppageInfo} from '@domain/stoppages'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

interface Causes {
  id: number
  title: string
  taskCount: number
  attachmentsCount: number
  commentsCount?: number
}

interface AnalysisSummary {
  id?: number
  title?: string
  description?: string
  stoppage?: StoppageInfo
  likelyCauses: Array<Causes>
}

export const QueryKey = 'analysis-summary'

export const useGetAnalysisSummary = (
  analysisId?: number,
  options?: UseQueryOptions<AnalysisSummary, AxiosError>
) => {
  return useQuery<AnalysisSummary, AxiosError>({
    queryKey: [QueryKey, analysisId],
    queryFn: async () => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}/finishsummary`
      return (await ApiClient.axiosInstance.get<AnalysisSummary>(path)).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError: true,
    retry: false,

    // allow the callee to override the default options
    ...options
  })
}
